import { IProcedureAttachment } from '../ProcedureAttachment';

export class ProcedureAttachmentsLogic {
  /**
   * Ritorna la lista degli attachment con il campo `order` settato.
   * Se il campo era null, viene sostituito dall'`id` dell'attachment + la lunghezza dell'array.
   * In questo modo, gli attachment con un ordine verranno sempre prima, mentre gli altri saranno
   * ordinati (grossomodo) in base alla loro creazione.
   */
  static setOrder(attachments: IProcedureAttachment[] | undefined) {
    if (!attachments) return [];
    return attachments.map(attachment => ({
      ...attachment,
      order: attachment.order ?? attachment.id + attachments.length
    }));
  }
}
